// Publish Wizard
export const PHOTOS = 'photos';
export const VISIBLE = 'visible';

// Showcase List Page
export const LIMIT_OPTIONS = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 25,
    label: 25,
  },
  {
    value: 50,
    label: 50,
  },
];

export const DEFAULT_LIMIT = LIMIT_OPTIONS[1];

// V2 Publish Wizard
export const MAIN = 'MAIN';
export const SELECT_COVER_PHOTO = 'SELECT_COVER_PHOTO';
export const HIDE_PHOTOS = 'HIDE_PHOTOS';
export const SELECT_PHOTOS = 'SELECT_PHOTOS';
export type WizardView =
  | typeof MAIN
  | typeof SELECT_COVER_PHOTO
  | typeof HIDE_PHOTOS
  | typeof SELECT_PHOTOS;

export const Confirm = {
  DELETE: 'DELETE',
} as const;
export type ConfirmComponentName = (typeof Confirm)[keyof typeof Confirm];
